import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import imageBanner from './img/imagem_banner_aulas.png';
import tiaAula from '@/assets/images/tia/TIA-AULA.png';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { Button } from '@/components/ui/button';
import { ModalSuccess, ModalSuccessBody, ModalSuccessContainer, ModalSuccessContent, ModalSuccessHeader, ModalSuccessImg, ModalSuccessName, ModalSuccessText } from '@/components/custom/modal';

export function CourseClassroomModalDisclaimer(props) {
  const { show, onClose, lessonName } = props;
  const playfulStudent = usePlayfulStudent();

  function closeOnEscapeKeyDown(event) {
    if (event.key === 'Escape') onClose();
  }

  useEffect(() => {
    document.body.addEventListener('keydown', closeOnEscapeKeyDown);

    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
      document.body.style.overflow = 'visible';
    };
  }, []);

  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [show]);

  const nodeRef = React.useRef(null); //Fix react-transition-group

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{ enter: 0, exit: 300 }}
    >
      <ModalSuccess
        isActive={show}
        onClick={onClose}
        ref={nodeRef}
        className={playfulStudent ? 'items-center' : undefined}
      >
        {playfulStudent ? (
          // Versão lúdica: T.I.A dando as boas-vindas no lugar da ilustração.
          <div
            onClick={event => event.stopPropagation()}
            className="w-[420px] max-w-[92vw] overflow-hidden rounded-[24px] bg-white shadow-[0_24px_48px_rgba(0,0,0,0.2)]"
          >
            <div
              className="flex justify-center rounded-t-[24px] pt-6"
              style={{ background: 'var(--color-bg-lilac)' }}
            >
              <img
                src={tiaAula}
                alt=""
                aria-hidden="true"
                className="h-36 w-auto object-contain object-bottom"
              />
            </div>

            <div className="flex flex-col items-center px-6 pb-6 pt-5 text-center">
              <h2
                className="mb-1 text-lg font-extrabold"
                style={{ color: '#222731' }}
              >
                Bem-vindo à aula!
              </h2>
              <p
                className="mb-3 text-sm font-bold"
                style={{ color: 'var(--color-secondary)' }}
              >
                {lessonName}
              </p>
              <p className="mb-6 text-sm font-semibold leading-relaxed text-neutral-500">Assista ao vídeo até o fim e responda às perguntas que aparecerem — é assim que a aula conta como concluída. 😉</p>

              <button
                type="button"
                autoFocus
                onClick={onClose}
                className="relative w-full overflow-hidden rounded-full py-3 text-sm font-extrabold text-white transition-transform duration-100 active:scale-[0.97]"
                style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 4px 0 var(--color-mission-dark), 0 6px 12px rgba(245,123,46,0.35)' }}
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full"
                  style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%)' }}
                />
                <span className="relative">Começar a aula 🚀</span>
              </button>
            </div>
          </div>
        ) : (
          <ModalSuccessContent
            isDisclaimer
            onClick={event => event.stopPropagation()}
          >
            <ModalSuccessImg
              src={imageBanner}
              alt=""
            />

            <ModalSuccessContainer>
              <ModalSuccessHeader>
                <ModalSuccessName>Bem vindo à aula:</ModalSuccessName>
              </ModalSuccessHeader>

              <ModalSuccessBody className="mb-0 flex flex-col gap-8">
                <ModalSuccessText>{lessonName}</ModalSuccessText>
                <ModalSuccessText className="rounded-sm border-2 border-solid border-[#442B8C] p-8">
                  <b>Atenção:</b> Para finalizar a aula, assista ao vídeo completo e responda às perguntas que surgirem.
                </ModalSuccessText>

                <Button
                  wide
                  onClick={onClose}
                >
                  Começar a aula
                </Button>
              </ModalSuccessBody>
            </ModalSuccessContainer>
          </ModalSuccessContent>
        )}
      </ModalSuccess>
    </CSSTransition>,
    document.getElementById('modal_root')
  );
}
